export default function genererMaterielFormat() {
  return {
    libelle: '',
    surface: {
      surfaceCommerciale: 0.00,
      surfaceTlpe: 0.00,
    },
  };
}
